import React, { useState } from 'react';
import { GAN_WX, ZHI_WX } from './tables.js';
import { tenGod } from './relations.js';
import { SHI_SHEN_MEANING, CHANGSHENG_MEANING } from './meanings.js';

const WX_COLOR = { 木: '#2e7d32', 火: '#c62828', 土: '#9c6b3f', 金: '#607d8b', 水: '#1565c0' };
const SHENG_NEXT = { 木: '火', 火: '土', 土: '金', 金: '水', 水: '木' };

function relWord(dWx, oWx) {
  if (dWx === oWx) return '比扶日主（同气帮身，亦分财）';
  if (SHENG_NEXT[dWx] === oWx) return '泄日主（我生者，付出耗力）';
  if (SHENG_NEXT[oWx] === dWx) return '生日主（受生者，得助得荫）';
  if (SHENG_NEXT[SHENG_NEXT[dWx]] === oWx) return '日主所克（我克者，财利可掌）';
  return '克日主（官杀临身，压力与权柄并至）';
}

function GzText({ gz }) {
  if (!gz) return null;
  return (
    <>{gz.split('').map((ch, j) => (
      <span key={j} style={{ color: WX_COLOR[(j === 0 ? GAN_WX : ZHI_WX)[ch]] || '#333' }}>{ch}</span>
    ))}</>
  );
}

export default function DayunStrip({ dayun, dayGan, qiyunText, dayunDir }) {
  const [openIdx, setOpenIdx] = useState(null);
  const steps = dayun.filter(d => d.ganzhi);
  const dWx = GAN_WX[dayGan];
  const thisYear = new Date().getFullYear();
  const currentIdx = steps.find(d => thisYear >= d.startYear && thisYear <= d.endYear)?.idx;

  return (
    <section className="panel bz-panel bz-dayun">
      <h4 className="sec-title">大运 · 每步十年</h4>
      <p className="dy-meta">
        {qiyunText && <span>起运：{qiyunText}</span>}
        {dayunDir && <span>排法：{dayunDir}</span>}
        <span className="dy-now-hint">高亮＝现行大运 · 点击展开详解与流年</span>
      </p>

      {/* 时间轴 */}
      <div className="dy-timeline">
        {steps.map((d) => {
          const isNow = d.idx === currentIdx;
          return (
            <button key={d.idx} type="button"
              className={`dy-cell ${openIdx === d.idx ? 'on' : ''} ${isNow ? 'now' : ''}`}
              onClick={() => setOpenIdx(openIdx === d.idx ? null : d.idx)}>
              {(isNow || d.chongTigang) && (
                <span className="dy-badges">
                  {isNow && <em className="dy-badge dy-badge-now">现行</em>}
                  {d.chongTigang && <em className="dy-badge dy-badge-warn" title="此运地支冲月柱提纲">冲提</em>}
                </span>
              )}
              <small className="dy-ages">{d.startAge}~{d.endAge}岁</small>
              <b className="dy-gz"><GzText gz={d.ganzhi} /></b>
              <i className="dy-shen">{d.tenShen}</i>
              <small className="dy-years">{d.startYear}~{d.endYear}</small>
            </button>
          );
        })}
      </div>

      {/* 展开详解 */}
      {openIdx != null && (() => {
        const d = steps.find(x => x.idx === openIdx);
        const gz = d.ganzhi;
        return (
          <div className="dayun-detail">
            <div className="dy-detail-grid">
              {/* 左：运程详解 */}
              <div className="dy-left">
                <div className="dy-head">
                  <b style={{ color: WX_COLOR[GAN_WX[gz[0]]] }}>{gz}</b>
                  <span>大运 · 第{d.idx}步</span>
                  <i>{d.startAge}~{d.endAge}岁（{d.startYear}~{d.endYear}年）</i>
                </div>
                <dl className="dy-facts">
                  <div><dt>天干十神</dt><dd><b style={{ color: '#8a4a12' }}>{d.tenShen}</b> —— {SHI_SHEN_MEANING[d.tenShen]}</dd></div>
                  <div><dt>与日主关系</dt><dd>{gz[0]}属{GAN_WX[gz[0]]}、日主{dayGan}属{dWx}：{relWord(dWx, GAN_WX[gz[0]])}</dd></div>
                  <div><dt>地支气数</dt><dd>{gz[1]}（{ZHI_WX[gz[1]]}）· 十二长生行<b>{d.csZhi}</b>：{CHANGSHENG_MEANING[d.csZhi]}</dd></div>
                </dl>
                {d.chongTigang && (
                  <p className="sec-warn" style={{ color: '#c62828' }}>
                    ⚠ 此运地支「{gz[1]}」冲月柱提纲：「运冲提纲，根基动摇」——十年间家庭事业根基多变动起伏，重大决策宜格外谨慎。
                  </p>
                )}
              </div>
              {/* 右：流年列表 */}
              <div className="dy-right">
                <h6>该步十年流年（附流年十神 · 以日主论）</h6>
                <div className="liunian-grid">
                  {(d.liunian || []).map((ln) => (
                    <span key={ln.year}
                      className={`liunian-cell ${ln.binglin ? 'binglin' : ''}`}
                      title={`${ln.year}年 ${ln.ganzhi}${ln.binglin ? ' · 岁运并临，吉凶加倍应验' : ''}${ln.chongDayun ? ' · 流年冲大运支' : ''}`}>
                      <i>{ln.year}</i>
                      <b><GzText gz={ln.ganzhi} /></b>
                      <small>{ln.age}岁 · {tenGod(dayGan, ln.ganzhi[0])}</small>
                      {ln.binglin && <em className="ln-flag ln-binglin">岁运并临</em>}
                      {!ln.binglin && ln.chongDayun && <em className="ln-flag ln-chong">冲运支</em>}
                    </span>
                  ))}
                </div>
              </div>
            </div>
            <p className="bz-tip">
              「岁运并临」＝流年与大运干支相同，古谓其年吉凶之力加倍应验；
              「冲运支」＝流年地支冲大运地支，主动荡变易。十神吉凶须结合全局喜忌参断。
            </p>
          </div>
        );
      })()}
    </section>
  );
}
